var map = {
	"./bakso.jpg": "f6f4",
	"./default.png": "6bcd",
	"./foods/bakso.jpg": "c1be",
	"./foods/kentang-goreng.jpg": "6f42",
	"./foods/lontong-opor-ayam.jpg": "c156",
	"./foods/menunggu.png": "a5e1",
	"./foods/mie-ayam-bakso.jpg": "7001",
	"./foods/mie-goreng.jpg": "dad8",
	"./foods/nasi-ayam-geprek.jpg": "2174",
	"./foods/nasi-goreng-telor.jpg": "83ac",
	"./foods/nasi-rames.jpg": "af77",
	"./foods/pangsit.jpg": "9980",
	"./foods/sate-ayam.jpg": "eda7",
	"./hero.png": "7a6c",
	"./kentang-goreng.jpg": "8da8",
	"./logo.png": "9d64",
	"./lontong-opor-ayam.jpg": "59d8",
	"./menunggu.png": "9219",
	"./mie-ayam-bakso.jpg": "0322",
	"./mie-goreng.jpg": "c594",
	"./nasi-ayam-geprek.jpg": "a4f1",
	"./nasi-goreng-telor.jpg": "7515",
	"./nasi-rames.jpg": "e38c",
	"./pangsit.jpg": "8a27",
	"./sate-ayam.jpg": "4dd0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";